import styled from '@emotion/styled';
import { css_fill, css_gap, css_stroke } from '~/emotion/theme';

const Section = styled.section`
	background: ${css_fill()};
	padding-top: ${css_gap('content')};
`;

const Wrapper = styled.section`
	border-top: 1px solid ${css_stroke()};
	border-bottom: 1px solid ${css_stroke()};
	line-height: 0;
`;

const Image = styled.img`
	width: 100%;
	height: 50vh;
	object-fit: cover;
`;

export default function MapBlockAlpha({ street }: { street: string }) {
	return (
		<Section id="map">
			<Wrapper>
				<Image src={street} />
			</Wrapper>
		</Section>
	);
}
